import React, {useState, useEffect} from "react";
import Api from "../../fetchs/Api";
import Modals from "../../componentesHTML/componentesSecundarios/Modals";
import BuscadorAreasGeograficas from ".././DOM/BuscadorAreasGeograficas";
import BuscadorDenue from ".././DOM/BuscadorDenue";
import BuscadorMicrodatos from ".././DOM/BuscadorMicrodatos";
import BuscadorDatosAbiertos from ".././DOM/BuscadorDatosAbiertos";
import BuscadorGlosario from ".././DOM/BuscadorGlosario";
import BuscadorNoticias from ".././DOM/BuscadorNoticias";
import BuscadorTabulados from ".././DOM/BuscadorTabulados";
import BuscadorPublicaciones from ".././DOM/BuscadorPublicaciones";
import BuscadorMapas from ".././DOM/BuscadorMapas";
import BuscadorTemas from ".././DOM/BuscadorTemas";
import BuscadorProgramas from ".././DOM/BuscadorProgramas";
import BuscadorInfraestructura from ".././DOM/BuscadorInfraestructura";
import BuscadorEnlace from ".././DOM/BuscadorEnlace";
import BuscadorInvestigacion from ".././DOM/BuscadorInvestigacion";
import BuscadorGenerales from ".././DOM/BuscadorGenerales";
import BuscadorIndicadores from ".././DOM/BuscadorIndicadores";
import BuscadorBie from ".././DOM/BuscadorBie";
import BuscadorBieBise from ".././DOM/BuscadorBieBise";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
import ApiInsertarBusqueda from "../../fetchs/ApiInsertarBusqueda";
function BuscadorTodo(parametros){
const _updateFiltros= useStoreGlobal(useShallow((state) => state._updateFiltros));
const _updateradioBie= useStoreGlobal(useShallow((state) => state._updateradioBie));
const _radioBie = useStoreGlobal(useShallow((state) => state._radioBie));

let var_ingles = "es";
let var_Resultado="Más resultados de "
let var_Resultado2=" en "
  document.getElementById("selectPestana").querySelectorAll("option").forEach(e => e.removeAttribute('selected'));
  if (window.location.href.indexOf("en.") > -1) {
    var_ingles = "en";
    var_Resultado=" More results of "
    var_Resultado2=" in "
  }
  let metodo="";
      if (parametros.metodoBusqueda === 1){
        metodo="Todas las palabras";
      }
      if (parametros.metodoBusqueda === 2){
        metodo="Cualquier palabra";
      }
      if (parametros.metodoBusqueda === 3){
        metodo="Frase completa";
      }
const param = {
  busqueda: parametros.textoBusqueda,
  busquedaCiencia: "",
  idioma: var_ingles,
  orderby: parametros.camposOrden,
  metodoBusqueda: parametros.metodoBusqueda
};
const apiData = Api("/app/api/buscadorcore/v1/busquedaTodos/", param,"0", metodo);
let nColeccion = "";
function nombrecoleccion(idColeccion, nombreColeccion) {
  const colecciones = {
    2: { es: "Áreas geográficas", en: "Geographic area" },
    3: { es: "Indicadores", en: "Indicators" },
    5: { es: "Publicaciones - Biblioteca digital", en: "Publications - Digital library" },
    6: { es: "Mapas - Biblioteca digital", en: "Maps - Digital library" },
    7: { es: "Programas de información", en: "Information programs" },
    8: { es: "Temas", en: "Topics" },
    9: { es: "BIE", en: "BIE" },
    13: { es: "DENUE", en: "DENUE" },
    14: { es: "Glosario", en: "Glossary" },
    21: { es: "Tabulados", en: "Tabular data" },
    19: { es: "Herramientas", en: "Tools" },
    26: { es: "Microdatos", en: "Microdata" },
    27: { es: "Datos abiertos", en: "Open data" },
    28: { es: "Investigación", en: "Investigation" },
    30: { es: "Noticias", en: "News" },
    31: { es: "Infraestructura de la información", en: "Information infrastructure" }
  };

  if (idColeccion === 25) {
    if (nombreColeccion === "AcercaINEGI") {
      nColeccion= var_ingles === "es" ? "Acerca del INEGI" : "About INEGI";
    }
    if (nombreColeccion === "Eventos") {
      nColeccion= var_ingles === "es" ? "Eventos" : "Events";
    }
  }

  const coleccion = colecciones[idColeccion];
  if (coleccion) {
    nColeccion= coleccion[var_ingles];
  }
  return nColeccion;
}
const MasResultados = (idcoleccion) => {
let nColeccion = "";
  const colecciones = {
    2: "Areageograficas",
    3: "Indicadores",
    5: "Publicaciones",
    6: "Mapas",
    7: "Programas",
    8: "Temas",
    9: "Bie",
    13: "DENUE",
    14: "Glosario",
    21: "Tabulados",
    19: "Herramientas",
    26: "Microdatos",
    27: "Datos_abiertos",
    28: "Investigación",
    30: "Noticias",
    31: "Infraestructura"
  };
const coleccion = colecciones[idcoleccion];
  if (coleccion) {
    nColeccion= coleccion;
  }

  if(nColeccion != "Bie"){
    let selectElement = document.getElementById("selectPestana");
    const option = selectElement.querySelector(`option[value="${nColeccion}"]`);
    option.setAttribute('selected', 'selected');
    const event = new Event('change', { bubbles: true });
    selectElement.dispatchEvent(event);
  }
  if(nColeccion == "Bie"){
    let cole2 = "Indicadores";
    let selectElement = document.getElementById("selectPestana");
    const option = selectElement.querySelector(`option[value="${cole2}"]`);
    option.setAttribute('selected', 'selected');
    const event = new Event('change', { bubbles: true });
    selectElement.dispatchEvent(event);
            const timerId = setTimeout(() => {
                $("#radioBie").trigger("click");
            }, 100);
            return () => {
                clearTimeout(timerId);
            };
  }
}
// const MasResultados = (coleccion) => {
//   if(coleccion != "Bie"){
//     let selectElement = document.getElementById("selectPestana");
//     const option = selectElement.querySelector(`option[value="${coleccion}"]`);
//     option.setAttribute('selected', 'selected');
//     const event = new Event('change', { bubbles: true });
//     selectElement.dispatchEvent(event);
//   }
//   if(coleccion == "Bie"){
 
//     let cole2 = "Indicadores";
//     let selectElement = document.getElementById("selectPestana");
//     const option = selectElement.querySelector(`option[value="${cole2}"]`);
//     option.setAttribute('selected', 'selected');
//     const event = new Event('change', { bubbles: true });
//     selectElement.dispatchEvent(event);
//             const timerId = setTimeout(() => {
//                 $("#radioBie").trigger("click");
//             }, 100);
//             return () => {
//                 clearTimeout(timerId);
//             };
//   }
// }
function RegistraBus(data){
  if(data.length > 0)
    ApiInsertarBusqueda(parametros.textoBusqueda ,"0",data.length, metodo);
  else
    ApiInsertarBusqueda(parametros.textoBusqueda ,"0", 0, metodo);
}
  useEffect(() => {
    if (!apiData.loading){
        RegistraBus(apiData.data)
    }
    if(apiData.data.length > 0) {
      document.getElementById('resultados').innerHTML= apiData.data.length;
    }
  },[apiData.data]);
  return(
    <>
      {apiData.loading? <Modals />:
        !apiData.loading && apiData.data?.map((datos,i) => (
        <div className = "col-xs-12 col-sm-12 todo" key={"coleccionBuscadorTodo-" + i} style={datos.COLECCION === 25? {marginBottom:"56px"}:  {marginBottom:"26px"}} id={"resultadoGeneral-" + i}>
          <div className="col-xs-12" id={"coleccion-" + i + "-"+ datos.COLECCION} style={{marginBottom:"10px"}}>
            <label className="col-lg-auto" id={"snippet_titulo_resultados-" + i} style={{paddingBottom:"5px", fontWeight:"bold", fontSize:"16px", paddingRight:"5px"}}>
              {nombrecoleccion(datos.COLECCION, datos.NOMBRE_COLECCION) + " - "}
            </label>
            {
              datos.COLECCION === 25? (<>
                  <label className="col-xs-12" style={{paddingTop:"0px", textAlign:"right", fontWeight:"bold"}} id={"snippet_mas_resultados-" + i}>
                    [<a style={{cursor:"pointer", color:"#00518b"}}  href={"#multiCollapseExample-" + i} data-bs-toggle="collapse" aria-controls={"multiCollapseExample-" + i}> {var_Resultado + parametros.textoBusqueda + var_Resultado2 + nColeccion}</a> ]
                  </label>
                  <div className="col-md-11" id={"snippet_row_Secundario-" + i} aria-expanded="true">
                    <div className="multi-collapse collapse" id={"multiCollapseExample-" + i} >
                      <BuscadorGenerales coleccionTodo = "cole" textoBusqueda = {parametros.textoBusqueda} coleccioDabiertos={datos.NOMBRE_COLECCION} titulo={datos.TITULO} url={datos.URL} id = {i} metodo = {parametros.metodoBusqueda}/>
                    </div>
                  </div>
                </>)
              :  (
                  <label className="col-lg-auto" id={"snippet_mas_resultados-" + i}>
                    [<a className = "text-decoration-underlin" style={{cursor:"pointer", color:"#00518b", fontWeight:"bold"}}  onClick={() => MasResultados(datos.COLECCION)}> {var_Resultado + parametros.textoBusqueda + var_Resultado2 + nColeccion}</a> ]
                  </label>
              )
            }
          </div>
          { 
            datos.COLECCION === 2?
            (
              <BuscadorAreasGeograficas coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 3?
            (
              <BuscadorIndicadores coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda} var_area_final={parametros.var_area_final}/>
            )
            :""
          }
          {
            datos.COLECCION === 5?
            (
              <BuscadorPublicaciones coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 6?
            (
              <BuscadorMapas coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
              
            )
            :""
          }
          {
            datos.COLECCION === 7?
            (
              <BuscadorProgramas coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 8?
            (
              <BuscadorTemas coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 9?
            (
              // <BuscadorBie coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
              <BuscadorBieBise coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>

            )
            :""
          }
          {
            datos.COLECCION === 13?
            (
              <BuscadorDenue coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 21?
            (
              <BuscadorTabulados coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 25?
            (
              <BuscadorGenerales coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 26?
            (
              <BuscadorMicrodatos coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 27?
            (
              <BuscadorDatosAbiertos coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 28?
            (
              <BuscadorInvestigacion coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 14?
            (
              <BuscadorGlosario coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 19?
            (
              <BuscadorEnlace coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 30?
            (
              <BuscadorNoticias coleccionTodo = "Todo" textoBusqueda = {parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
          {
            datos.COLECCION === 31?
            (
              <BuscadorInfraestructura coleccionTodo = "Todo"  textoBusqueda={parametros.textoBusqueda} datos = {datos} id = {i} metodo = {parametros.metodoBusqueda}/>
            )
            :""
          }
        </div>
        ))
      }
  </>)
}
export default BuscadorTodo;